module.exports = __webpack_public_path__ + "static/js-front-a0f8c76b454c57cf469c0328a9553590.svg";